<template>
  <v-snackbar v-model="snackbar" :timeout="timeout">
    <div v-html="notice">
      {{notice}}
    </div>
    <template v-slot:action="{ attrs }">
      <v-btn
        text
        v-if="redirect"
        @click.stop="goToProject"
      >
        Ir al proyecto
      </v-btn>
      <v-btn
        text
        v-bind="attrs"
        @click="snackbar = false"
      >
        X
      </v-btn>
    </template>
  </v-snackbar>
</template>
<script>
export default {
  data: ()=> ({
    snackbar: false,
    timeoutDefault:1000,
    notice: undefined,
    snackTimeout: undefined,
    redirect:undefined
  }),
  computed:{
    trigger(){
      return this.$store.getters.getSnackTrigger
    },
    timeout(){
      var to =this.snackTimeout
      if(to)
        return to
      else
        return this.timeoutDefault
    },
  },
  beforeDestroy(){
    this.$store.dispatch('clearSnack')
    this.snackbar = false
  },
  methods:{
    goToProject(){
      this.$router.push('/projects/'+ this.redirect)
      this.snackbar = false      
    }
  },
  watch: {
    trigger: function(value){
      if(value){
        this.snackbar = value
        var snackInfo = this.$store.getters.getSnackSettings
      
        this.notice = snackInfo.text
        this.snackTimeout = snackInfo.timeout
        this.redirect = snackInfo.redirect
      }
    },
    snackbar:function(value){
      if(!value){
        this.$store.commit('setSnackTrigger',false)
        this.$store.commit('setSnackTimeout', undefined)
      }
    }
  }
}
</script>
